import { BrowserRouter as Router } from 'react-router-dom';

// context
import AuthProvider from './context/AuthProvider/AuthProvider';
import { CartProvider } from './context/CartProvider/CartProvider';
import { SearchProvider } from './context/SearchProvider/SearchProvider';
import AppUIProvider from './context/AppUIProvider/AppUIProvider';
import { CheckoutProvider } from 'src/context/CheckoutProvider/CheckoutProvider';
import { ThemeProvider } from '@mui/material/styles';
import QueryProvider from './context/QueryProvider/QueryProvider';
import { AppLaunchNotificationProvider } from 'src/context/AppLaunchNotificationsProvider/AppLaunchNotificationsProvider';
import { AmplitudeProvider } from 'src/context/AmplitudeProvider';
import { GrowthBookProvider } from '@growthbook/growthbook-react';

import { CssBaseline, GlobalStyles } from '@mui/material';
import LayoutWrapper from './common/layout/LayoutWrapper';
import PushNotificationsContainer from 'src/context/PushNotificationsProvider/PushNotificationsProvider';
import useTrackingPermission from 'src/common/hooks/useTrackingPermission/useTrackingPermission';
import sentry from 'src/utils/sentry';
import RoutesConfig from 'src/routes/config';
import * as Sentry from '@sentry/react';
import AgeValidationDrawer from 'src/features/auth/presentation/AgeValidationDrawer';
import growthbook from 'src/utils/growthBook/growthBook';
import { useEffect } from 'react';
import AppUrlListener from 'src/components/AppUrlListener';
import InAppNotificationsProvider from 'src/context/InAppNotificationsProvider/InAppNotificationsProvider';
import { Capacitor } from '@capacitor/core';
import { Badge } from '@capawesome/capacitor-badge';
import VerificationProvider from 'src/features/auth/presentation/context/VerificationProvider';
import ErrorFallback from 'src/routes/ErrorFallback';
import getTheme from 'src/utils/themes/getTheme';
import globalStyles from 'src/globalStyles';
import useFaviconAndTitle from 'src/common/hooks/useFaviconAndTitle/useFaviconAndTitle';
import PathNormalizationProvider from 'src/context/PathNormalizationProvider';

sentry.install();

function App() {
  const currentTheme = getTheme();
  useTrackingPermission();
  useFaviconAndTitle();

  useEffect(() => {
    growthbook.refreshFeatures();

    const clearBadge = async () => {
      const platform = Capacitor.getPlatform();
      const isMobile = platform === 'ios' || platform === 'android';

      if (isMobile) {
        await Badge.clear();
      }
    };

    clearBadge();
  }, []);

  return (
    <Sentry.ErrorBoundary fallback={ErrorFallback}>
      <GrowthBookProvider growthbook={growthbook}>
        <QueryProvider>
          <ThemeProvider theme={currentTheme}>
            <CssBaseline />
            <GlobalStyles styles={(theme) => globalStyles(theme)} />
            <Router>
              <PathNormalizationProvider>
                <AmplitudeProvider>
                  <AppUrlListener />
                  <AppUIProvider>
                    <AuthProvider>
                      <AgeValidationDrawer>
                        <InAppNotificationsProvider>
                          <VerificationProvider>
                            <AppLaunchNotificationProvider>
                              <PushNotificationsContainer>
                                <CartProvider>
                                  <CheckoutProvider>
                                    <SearchProvider>
                                      <LayoutWrapper>
                                        <RoutesConfig />
                                      </LayoutWrapper>
                                    </SearchProvider>
                                  </CheckoutProvider>
                                </CartProvider>
                              </PushNotificationsContainer>
                            </AppLaunchNotificationProvider>
                          </VerificationProvider>
                        </InAppNotificationsProvider>
                      </AgeValidationDrawer>
                    </AuthProvider>
                  </AppUIProvider>
                </AmplitudeProvider>
              </PathNormalizationProvider>
            </Router>
          </ThemeProvider>
        </QueryProvider>
      </GrowthBookProvider>
    </Sentry.ErrorBoundary>
  );
}

export default App;
